<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                :total-items="totalItems"
                :rows-per-page-items="[10,25,50]"
                class="elevation-1"
                item-key="driverId"
                must-sort
                :pagination.sync="pagination"
                >
                <template slot="items" slot-scope="props">           
                  <td class="text-sm-center">{{ props.item.driverId }}</td>
                  <td class="text-sm-center">{{ props.item.driverName }}</td>
                  <td class="text-sm-center">{{ props.item.phoneNumber }}</td>
                  <td class="text-sm-center">{{ props.item.taxiNum }}</td>
                  <td class="text-sm-center">{{ changeRunningStateText(props.item.driverStatus) }}</td>
                  <td class="text-sm-center">
                    <a :href="'https://www.google.com/maps/place/' + props.item.latitude + ',' + props.item.longitude" target="_blank">
                      {{ props.item.latitude + ', ' + props.item.longitude }}
                    </a>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import RunningState  from '@/api/runningState';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      autoReload: true,
      pagination: {
        descending: true,
        rowsPerPage: 10,
        page: 1,
        sortBy: 'id'
      },
      totalItems: 0,
      complex: {
        headers: [
          {
            text: '기사 번호',
            value: 'driverId',
            align: 'center',
            sortable: false
          },
          {
            text: '이름',
            value: 'driverName',
            align: 'center',
            sortable: false
          },
          {
            text: '전화번호',
            value: 'phoneNumber',
            align: 'center',
            sortable: false
          },
          {
            text: '택시번호',
            value: 'taxiNum',
            align: 'center',
            sortable: false
          },
          {
            text: '기사상태',
            value: 'driverStatus',
            align: 'center',
            sortable: false
          },
          {
            text: '위치',
            value: 'latitude',
            align: 'center',
            sortable: false
          }
        ],
        items: []
      },
      runningState: RunningState
    };
  },
  watch: {
    'pagination' () {
      if (this.pagination.totalItems !== 0 && top.getApp.prevPagination != null) {
        if (top.getApp.prevPageName === 'RunningDriverPage') {
          this.pagination = top.getApp.prevPagination;
        }
        top.getApp.prevPagination = null;
        top.getApp.prevPageName = null;
      }
      this.banbanCreated();
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
  },
  methods: {
    banbanCreated () {
      const parameters = {
        method: 'runningDrivers',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
      };

      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          this.complex.items = data.content;
          this.totalItems = data.totalElements;

          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    changeRunningStateText (stateCode) {
      if (stateCode != null) {
        for (let i = 0; i < this.runningState.length; i++) {
          if (this.runningState[i].state === stateCode) {
            return this.runningState[i].text;
          }
        }
      } else {
        return '';
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/call/RunningDrivers.vue